export default __webpack_public_path__ + "static/media/kitchen4-afterB.4fe0f1cf.jpg";